import React from 'react'
import {setFileName} from "../actions"
import {connect} from 'react-redux'
import {StyledLi, StyledInput} from '../styled-components/components'

const DocumentTitle = ({title, dispatch}) => {
   return (<StyledLi><StyledInput placeholder="Document Title..." type="text" value={title} onChange={(e)=>dispatch(setFileName(e.target.value))}  /></StyledLi>)
}

function mapStateToProps(state) {
   return {
      title : state.document
   }
}

export default connect(mapStateToProps)(DocumentTitle)